import createReducer from '../createReducer';

const initialState = {
    promotionMessages:[],
    getPromotionMessagesXHR:null,
};

const reducer = createReducer('promotion', initialState);

export default reducer;